/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * contents object
 * @export
 * @interface PutCharactersCharacterIdMailMailIdContents
 */
export interface PutCharactersCharacterIdMailMailIdContents {
    /**
     * Labels to assign to the mail. Pre-existing labels are unassigned.
     * @type {Array<number>}
     * @memberof PutCharactersCharacterIdMailMailIdContents
     */
    labels?: Array<number>;
    /**
     * Whether the mail is flagged as read
     * @type {boolean}
     * @memberof PutCharactersCharacterIdMailMailIdContents
     */
    read?: boolean;
}

/**
 * Check if a given object implements the PutCharactersCharacterIdMailMailIdContents interface.
 */
export function instanceOfPutCharactersCharacterIdMailMailIdContents(value: object): value is PutCharactersCharacterIdMailMailIdContents {
    return true;
}

export function PutCharactersCharacterIdMailMailIdContentsFromJSON(json: any): PutCharactersCharacterIdMailMailIdContents {
    return PutCharactersCharacterIdMailMailIdContentsFromJSONTyped(json, false);
}

export function PutCharactersCharacterIdMailMailIdContentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutCharactersCharacterIdMailMailIdContents {
    if (json == null) {
        return json;
    }
    return {
        
        'labels': json['labels'] == null ? undefined : json['labels'],
        'read': json['read'] == null ? undefined : json['read'],
    };
}

export function PutCharactersCharacterIdMailMailIdContentsToJSON(json: any): PutCharactersCharacterIdMailMailIdContents {
    return PutCharactersCharacterIdMailMailIdContentsToJSONTyped(json, false);
}

export function PutCharactersCharacterIdMailMailIdContentsToJSONTyped(value?: PutCharactersCharacterIdMailMailIdContents | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'labels': value['labels'],
        'read': value['read'],
    };
}

